import { useEffect, useState } from "react";
import api from "../api/PosApi";
import { Card, Container, Row, Col } from "react-bootstrap";


function useDebounce(value: any, delay: any) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default function Clientes() {
  const [term, setTerm] = useState("");
  const [clientes, setClientes] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [actividades, setActividades] = useState([]);
  const [terminoActividad, setTerminoActividad] = useState('');
  const debouncedActividad = useDebounce(terminoActividad, 1000);

  const buscarActividad = async (termino: string) => {
    try {
      const response = await api.get(`/pos/actividad/filtrar?term=${encodeURIComponent(termino)}`);
      setActividades(response.data);
    } catch (error) {
      console.error('Error al buscar actividades activas:', error);
    }
  }

  const [nuevo, setNuevo] = useState({
    tipoDocumento: "36", // DUI por defecto
    numeroDocumento: "",
    nombre: "",
    direccionDepartamento: "05",
    direccionMunicipio: "06",
    direccionComplemento: "",
    telefono: "",
    correo: "",
    actividadEconomica: "",
    nrc: "",
    nombreComercial: "",
    tipoContribuyente: "",
    ivaStatus: "normal"
  });
  const [mensaje, setMensaje] = useState("");

  const buscar = async () => {
    try {
      const res = await api.get(`/pos/clientes?term=${term}`);
      setClientes(res.data);
      setMensaje("");
    } catch {
      setMensaje("❌ Error al buscar clientes");
    }
  };

  const crearCliente = async () => {
    try {
      if (!nuevo.numeroDocumento || !nuevo.nombre || !nuevo.telefono || !nuevo.correo || !nuevo.nombreComercial) {
        setMensaje("⚠️ Debes llenar todos los campos obligatorios (Documento, nombre, telefono, correo, nombre comercial).");
        return;
      }
      const res = await api.post("/pos/clientes", nuevo);
      setMensaje(`✅ Cliente creado: ${res.data.nombre}`);
      setNuevo({
        tipoDocumento: "36",
        numeroDocumento: "",
        nombre: "",
        direccionDepartamento: "05",
        direccionMunicipio: "06",
        direccionComplemento: "",
        telefono: "",
        correo: "",
        actividadEconomica: "",
        nrc: "",
        nombreComercial: "",
        tipoContribuyente: "",
        ivaStatus: "normal"
      });
    } catch {
      setMensaje("❌ Error al crear cliente");
    }
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // Limpiar espacios y guiones solo en inputs de texto
    const limpio =
      type === "text" || type === "tel"
        ? value.replace(/[\s-]/g, "")
        : value;

    setNuevo((prev) => ({ ...prev, [name]: limpio }));
  };

  const hanndleClickActividad = (actividad: any) => {
    setNuevo({ ...nuevo, actividadEconomica: actividad.codigo })
    setActividades([]); // Limpiar la lista de sugerencias
    setTerminoActividad(actividad.nombre);
  };

  // ✅ Si quieres filtrar municipios según el departamento seleccionado:
  const municipiosFiltrados = municipios.filter(
    (m) => m.departamentoCodigo === nuevo.direccionDepartamento
  );

  useEffect(() => {
    const fetchCatalogos = async () => {
      try {
        const [depsRes, munRes] = await Promise.all([
          api.get("/pos/departamentos/todos"),
          api.get("/pos/municipios/todos"),
        ]);
        setDepartamentos(depsRes.data);
        setMunicipios(munRes.data);
      } catch (err) {
        console.log("Error al cargar la promesa, municipio o departamento: " + err)
      }
    }
    fetchCatalogos();
  },
    []
  );

  useEffect(() => {
    if (debouncedActividad) {
      buscarActividad(debouncedActividad);
    } else {
      setActividades([]);
    }
  },
    [debouncedActividad]);

  return (
    <Container>
      <Row>
        <Col>
          <Card className="card-black mb-3">
            <Card.Header>
              <h3>Gestión de Clientes</h3>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col xl={10}>
                  <input
                    placeholder="Nombre o NIT"
                    className="form-control"
                    value={term}
                    onChange={(e) => setTerm(e.target.value)}
                  />
                </Col>
                <Col xl={2}>
                  <button onClick={buscar} className="btn btn-primary w-100">Buscar</button>
                </Col>
              </Row>

              <Row>
                <Col>
                  <ul>
                    {clientes.map((c: any) => (
                      <li key={c.id}>
                        {c.nombre} ({c.numeroDocumento})
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card className="card-black">
            <Card.Header>
              <h3>Añadir nuevos Clientes</h3>
            </Card.Header>
            <Card.Body>
              <Row className="mb-3">
                <Col className="form-group">
                  <label htmlFor="dui">Documento DUI|NIT:</label>
                  <input
                    className="form-control"
                    id="dui"
                    name="dui"
                    placeholder="Documento (DUI/NIT)"
                    value={nuevo.numeroDocumento}
                    onChange={(e) =>
                      setNuevo({ ...nuevo, numeroDocumento: e.target.value })
                    }
                  />
                </Col>
                <Col className="form-group">
                  <label htmlFor="nombre">Nombre:</label>
                  <input
                    id="nombre"
                    name="nombre"
                    placeholder="Nombre"
                    className="form-control"
                    value={nuevo.nombre}
                    onChange={(e) => setNuevo({ ...nuevo, nombre: e.target.value })}
                  />
                </Col>
                <Col className="form-group">
                  <label htmlFor="phone">Telefono:</label>
                  <input
                    id="phone"
                    name="phone"
                    className="form-control"
                    placeholder="Teléfono"
                    value={nuevo.telefono}
                    onChange={(e) => setNuevo({ ...nuevo, telefono: e.target.value })}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col className="form-group">
                  <label htmlFor="comercialName">Nombre Comercial:</label>
                  <input
                    placeholder="Nombre Comercial"
                    id="comercialName"
                    name="comercialName"
                    className="form-control"
                    value={nuevo.nombreComercial}
                    onChange={(e) =>
                      setNuevo({ ...nuevo, nombreComercial: e.target.value })
                    }
                  />
                </Col>
                <Col className="form-group">
                  <label htmlFor="direccion">Dirección:</label>
                  <input
                    placeholder="Dirección"
                    id="direccion"
                    name="direccion"
                    className="form-control"
                    value={nuevo.direccionComplemento}
                    onChange={(e) =>
                      setNuevo({ ...nuevo, direccionComplemento: e.target.value })
                    }
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col className="form-group">
                  <label htmlFor="mail">Correo:</label>
                  <input
                    id="mail"
                    name="mail"
                    className="form-control"
                    placeholder="Correo"
                    type="mail"
                    value={nuevo.correo}
                    onChange={(e) => setNuevo({ ...nuevo, correo: e.target.value })}
                  />

                </Col>
                <Col className="form-group">
                  <label htmlFor="nrc">NRC:</label>
                  <input
                    id="nrc"
                    name="nrc"
                    className="form-control"
                    placeholder="nrc"
                    value={nuevo.nrc}
                    onChange={(e) =>
                      setNuevo({ ...nuevo, nrc: e.target.value })
                    }
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col className="form-group">
                  <label htmlFor="actEc">Actividad Economica:</label>
                  <input
                    id="actEc"
                    name="actEc"
                    className="form-control"
                    placeholder="Actividad Economica"
                    value={terminoActividad}
                    onChange={(e) =>
                      setTerminoActividad(e.target.value)
                    }
                  />
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col xl={12}>
                  {actividades.length > 0 && (
                    <ul className="cliente-suggestions list-group">
                      {actividades.map((p: any) => (
                        <li className='list-group-item list-group-item-action' key={p.codigo} onClick={() => hanndleClickActividad(p)}>
                          {p.codigo} - {p.nombre}
                        </li>
                      ))}
                    </ul>
                  )}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col className="form-group">
                  <label htmlFor="dpto">Departamento:</label>
                  <select id="dpto" className="form-control"
                    name="direccionDepartamento"
                    value={nuevo.direccionDepartamento}
                    onChange={handleChange}>
                    {departamentos.map((d) => (
                      <option key={d.codigo} value={d.codigo}>
                        {d.nombre}
                      </option>
                    ))}
                  </select>
                </Col>
                <Col className="form-group">
                  <label htmlFor="municipio">Municipio:</label>
                  <select id="municipio" className="form-control"
                    name="direccionMunicipio"
                    value={nuevo.direccionMunicipio}
                    onChange={handleChange}>
                    {municipiosFiltrados.map((m) => (
                      <option key={m.codigo} value={m.codigo}>
                        {m.nombre}
                      </option>
                    ))}
                  </select>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col className="form-group">
                  <label htmlFor="tipoContribuyente">Tipo Contribuyente:</label>
                  <select name="tipoContribuyente" id="tipoContribuyente" className="form-control"
                    value={nuevo.tipoContribuyente}
                    onChange={(e) =>
                      setNuevo({ ...nuevo, tipoContribuyente: e.target.value })
                    }>
                    <option value="Otros" selected>Otros</option>
                    <option value="Grande">Grande</option>
                    <option value="Mediano">Mediano</option>
                  </select>
                </Col>
                <Col className="form-group">
                  <label htmlFor="ivaStatus">Tipo Iva:</label>
                  <select name="ivaStatus" id="ivaStatus" className="form-control"
                    value={nuevo.ivaStatus}
                    onChange={(e) =>
                      setNuevo({ ...nuevo, ivaStatus: e.target.value })
                    }>
                    <option value="normal" selected>Normal</option>
                    <option value="retiene">Retiene</option>
                    <option value="exento">Exento</option>
                  </select>
                </Col>
              </Row>
              <Row>
                <Col>
                  <button className="btn btn-success w-100" onClick={crearCliente}>Guardar Cliente</button>
                </Col>
              </Row>
              <Row>
                <Col>
                  {mensaje && <p>{mensaje}</p>}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
